export const managerMisc = {
  // Shared field / label strings reused across the advisor and user views
  fields: {
    name: "Prénom",
    lastname: "Nom",
    email: "Adresse e-mail",
    idNumber: "Numéro de pièce d'identité",
    phone: "Téléphone",
  },
  // src/views/Manager/pagos/index.vue
  pagos: {
    title: "Factures de paiement",
    subtitle: "Liste des paiements effectués par les utilisateurs",
    emailUser: "E-mail de l'utilisateur",
    value: "Montant",
    issueDate: "Date d'émission",
    status: "Statut",
    downloadInvoice: "Télécharger la facture",
    generatingInvoice: "Génération de la facture ...",
    almostDone: "Presque terminé, veuillez patienter ...",
    loading: "Chargement ...",
    invoiceError: "Désolé, la facture n'a pas pu être générée",
  },
  // src/views/Manager/advisors/* and src/components/manager/advisors/*
  advisors: {
    title: "Conseillers de la plateforme",
    subtitle: "Liste des conseillers.",
    createNew: "Créer un nouveau",
    thId: "ID",
    thRefCode: "Code réf.",
    thEmail: "E-mail",
    thRegisterDate: "Date d'inscription",
    deleteConfirmMsg: "Êtes-vous sûr de vouloir supprimer ce conseiller ?",
    deleteConfirmHeader: "Confirmer",
    menuUpdateInfo: "Mettre à jour les informations",
    menuAffiliatesList: "Liste des affiliés",
    menuDelete: "Supprimer",
    createTitle: "Créer un nouveau conseiller",
    savingInfo: "Enregistrement des informations...",
    saveAdvisor: "Enregistrer le conseiller",
    updateTitle: "Mettre à jour les détails du conseiller",
    updatingInfo: "Mise à jour des informations...",
    updateAdvisor: "Mettre à jour le conseiller",
    cancel: "Annuler",
  },
  // src/components/manager/advisors/modalListAffiliates.vue
  affiliates: {
    listTitle: "Liste des affiliés",
    emptyPre: "Aucun utilisateur n'est affilié au code",
  },
  // src/components/manager/users/menuRoutes.vue
  menu: {
    checkinsDone: "Check-ins terminés",
    checkinsPending: "Check-ins en attente",
    checkinsScheduled: "Check-ins programmés",
    logoAndName: "Logo et nom de l'hébergement",
    welcomeMessage: "Message de bienvenue",
    policies: "Politiques de l'hébergement",
    roomKeys: "Clés des chambres",
    authorities: "Autorités",
    guestReviews: "Avis des clients",
  },
  // src/components/manager/users/accommodations.vue
  accommodations: {
    createdDate: "Date de création",
    checkins: "Check-ins",
  },
  // src/views/Manager/index.vue
  dashboard: {
    title: "Panneau d'administration",
    subtitle: "Liste des statistiques de la plateforme",
    registeredUsers: "Utilisateurs inscrits",
    viewList: "Voir la liste",
    propertiesCreated: "Établissements créés",
    checkinsDone: "Check-ins terminés",
  },
};
